var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.02 19.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.02,1.77h-2.18v-.77c0-.55-.45-1-1-1s-1,.45-1,1v.77H1c-.55,0-1,.45-1,1s.45,1,1,1h12.84v.77c0,.55.45,1,1,1s1-.45,1-1v-.77h2.18c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.02,8.77H4.71v-.77c0-.55-.45-1-1-1s-1,.45-1,1v.77h-1.71c-.55,0-1,.45-1,1s.45,1,1,1h1.71v.77c0,.55.45,1,1,1s1-.45,1-1v-.77h13.31c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.02,15.77h-9.06v-.77c0-.55-.45-1-1-1s-1,.45-1,1v.77H1c-.55,0-1,.45-1,1s.45,1,1,1h5.96v.77c0,.55.45,1,1,1s1-.45,1-1v-.77h9.06c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters-icon.dac50b6e097bde361dbea8afd952b253.svg";
export { ForwardRef as ReactComponent };